export default "__VITE_ASSET__4eea133e__"